// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"1c0b6dbd","787":"e83109db"}[chunkId] + ".chunk.js";
};